module.exports = __webpack_public_path__ + "a7e01feeac393d8295c9cbbe355e37cf.svg";